<div class="theming-crud appearance-crud mm-page">
  <header class="qa-theming-header">
    <div class="qa-theming-title">
      <h2>{{_(KEYS.THEMING.APPEARANCE)}}</h2>
      <p>{{_("Darstellung der Verwaltungsoberfläche und der Ausfüll-App für alle Benutzer dieser Instanz.")}}</p>
    </div>
    <div class="qa-theming-actions">
      <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!dirty">
        <i class="fa fa-save" aria-hidden="true"></i> {{_("Speichern")}}
      </button>
    </div>
  </header>

  <h3 class="qa-appearance-group">{{_(KEYS.THEMING.ADMIN)}}</h3>
  <div class="qa-appearance-list">
    <ng-container *ngFor="let item of adminSwitches">
      <ng-container *ngTemplateOutlet="switchCard; context: {$implicit: item}"></ng-container>
    </ng-container>
  </div>

  <h3 class="qa-appearance-group">{{_(KEYS.THEMING.APP)}}</h3>
  <div class="qa-appearance-list">
    <ng-container *ngFor="let item of appSwitches">
      <ng-container *ngTemplateOutlet="switchCard; context: {$implicit: item}"></ng-container>
    </ng-container>
  </div>
</div>

<!-- one switch: text with the default on the left, the choices with a sketch on the right -->
<ng-template #switchCard let-item>
  <section class="qa-theming-card qa-appearance-item">
    <div class="qa-appearance-text">
      <h3><i class="fa" [ngClass]="item.icon" aria-hidden="true"></i> {{_(item.title)}}</h3>
      <p class="qa-theming-text">{{_(item.text)}}</p>
      <p class="qa-appearance-preset">
        <ng-container *ngIf="draft[item.key]; else usesPreset">
          {{_("Vorgabe")}}: {{label(item.key, preset(item.key))}} ·
          <button type="button" class="qa-appearance-reset" (click)="reset(item.key)">{{_("Vorgabe verwenden")}}</button>
        </ng-container>
        <ng-template #usesPreset><i class="fa fa-check" aria-hidden="true"></i> {{_("Vorgabe wird verwendet")}}</ng-template>
      </p>
    </div>
    <div class="qa-appearance-options" role="radiogroup" [attr.aria-label]="_(item.title)">
      <button type="button" role="radio" class="qa-appearance-option" *ngFor="let option of item.options"
              [attr.aria-checked]="selected(item.key) === option.value" [class.active]="selected(item.key) === option.value"
              (click)="choose(item.key, option.value)">
        <ng-container *ngTemplateOutlet="sketch; context: {$implicit: item.key + '-' + option.value}"></ng-container>
        <span class="qa-appearance-option-label">
          <i class="fa" [ngClass]="selected(item.key) === option.value ? 'fa-dot-circle-o' : 'fa-circle-o'" aria-hidden="true"></i>
          {{_(option.label)}}
        </span>
      </button>
    </div>
  </section>
</ng-template>

<!-- small sketches of every choice, painted with the theme tokens -->
<ng-template #sketch let-choice>
  <span class="qa-mini" [ngSwitch]="choice" aria-hidden="true">
    <ng-container *ngSwitchCase="'theme-new'">
      <span class="qa-mini-side"><i class="qa-mini-logo"></i><i class="qa-mini-nav on"></i><i class="qa-mini-nav"></i><i class="qa-mini-nav"></i></span>
      <span class="qa-mini-main">
        <i class="qa-mini-title"></i>
        <span class="qa-mini-card qa-mini-round"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i><i class="qa-mini-button qa-mini-round"></i></span>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'theme-classic'">
      <span class="qa-mini-side qa-mini-side-classic"><i class="qa-mini-logo"></i><i class="qa-mini-row on"></i><i class="qa-mini-row"></i><i class="qa-mini-row"></i></span>
      <span class="qa-mini-main qa-mini-main-classic">
        <i class="qa-mini-title dark"></i>
        <span class="qa-mini-card qa-mini-square"><i class="qa-mini-bar"></i><i class="qa-mini-line"></i><i class="qa-mini-button qa-mini-square"></i></span>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'editor-new'">
      <span class="qa-mini-pane qa-mini-palette"><i class="qa-mini-chip"></i><i class="qa-mini-chip"></i><i class="qa-mini-chip"></i></span>
      <span class="qa-mini-pane qa-mini-document">
        <span class="qa-mini-card qa-mini-round on"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i></span>
        <span class="qa-mini-card qa-mini-round"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i></span>
      </span>
      <span class="qa-mini-pane qa-mini-props"><i class="qa-mini-line"></i><i class="qa-mini-field"></i><i class="qa-mini-line short"></i><i class="qa-mini-field"></i></span>
    </ng-container>
    <ng-container *ngSwitchCase="'editor-classic'">
      <span class="qa-mini-pane qa-mini-document qa-mini-single">
        <span class="qa-mini-card qa-mini-square"><i class="qa-mini-bar dark"></i><i class="qa-mini-field"></i><i class="qa-mini-field short"></i></span>
        <span class="qa-mini-card qa-mini-square"><i class="qa-mini-bar dark"></i><i class="qa-mini-field"></i></span>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'appDesign-modern'">
      <span class="qa-mini-tablet">
        <i class="qa-mini-app-head"></i>
        <span class="qa-mini-card qa-mini-round"><i class="qa-mini-line"></i><i class="qa-mini-option qa-mini-round"></i><i class="qa-mini-option qa-mini-round"></i></span>
        <i class="qa-mini-button qa-mini-round"></i>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'appDesign-classic'">
      <span class="qa-mini-tablet">
        <i class="qa-mini-app-head dark"></i>
        <span class="qa-mini-card qa-mini-square"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i></span>
        <i class="qa-mini-button qa-mini-square"></i>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'submenu-top'">
      <span class="qa-mini-side qa-mini-side-narrow"><i class="qa-mini-dot"></i><i class="qa-mini-dot on"></i><i class="qa-mini-dot"></i><i class="qa-mini-dot"></i></span>
      <span class="qa-mini-main">
        <span class="qa-mini-tabs"><i class="on"></i><i></i><i></i></span>
        <span class="qa-mini-card qa-mini-round"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i></span>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'submenu-left'">
      <span class="qa-mini-side qa-mini-side-wide">
        <i class="qa-mini-nav"></i><i class="qa-mini-nav open"></i><i class="qa-mini-sub on"></i><i class="qa-mini-sub"></i><i class="qa-mini-sub"></i><i class="qa-mini-nav"></i>
      </span>
      <span class="qa-mini-main">
        <i class="qa-mini-title"></i>
        <span class="qa-mini-card qa-mini-round"><i class="qa-mini-line"></i><i class="qa-mini-line short"></i></span>
      </span>
    </ng-container>
  </span>
</ng-template>
